import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { usePostHog } from "@/analytics/usePostHog";
import { ArrowRight, MapPin } from "lucide-react";
import { localizePath } from "@/lib/localeRoutes";

interface ServiceArticleCalloutProps {
  articleSlug: string;
}

export const ServiceArticleCallout = ({
  articleSlug,
}: ServiceArticleCalloutProps) => {
  const { t, i18n } = useTranslation("doctorVisits");
  const posthog = usePostHog();

  return (
    <aside
      data-service-callout="doctor-visits"
      className="mt-12 border-y border-primary/20 bg-accent/60 px-5 py-7 sm:px-7"
    >
      <div className="flex gap-4">
        <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
          <MapPin className="h-5 w-5" aria-hidden="true" />
        </span>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary">
            {t("articleCallout.eyebrow")}
          </p>
          <h2 className="mt-2 text-xl font-bold text-foreground">
            {t("articleCallout.title")}
          </h2>
          <p className="mt-2 leading-7 text-muted-foreground">
            {t("articleCallout.description")}
          </p>
          <Link
            to={localizePath("/doctor-visits", i18n.language)}
            className="mt-4 inline-flex min-h-11 items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            onClick={() =>
              posthog?.capture("service_guidance_clicked", {
                destination: "doctor-visits",
                source_article: articleSlug,
                service: "doctor_visits",
              })
            }
          >
            {t("articleCallout.link")}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </aside>
  );
};
